var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dropdown-item',_vm._b({class:{
    active: _vm.isActive,
    header: _vm.isHeader,
  },attrs:{"divided":_vm.hasDividerAbove}},'el-dropdown-item',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }